import { CHRISTMAS, CULTURE, FEED, MEAL } from '../../constants/product-types'
import * as product from '../types/internalProduct'
import { CREDIT_CARD_PAYMENT } from '../../constants/environment'

export const initialState = {
    code: null,
    min: 0,
    max: 0,
    products: [
        {
            code: FEED,
            category: '',
            benefits: [
                {
                    icon: 'para_que_serve.svg',
                    title: 'Para que serve',
                    description:
                        'Substitui a cesta física e dá mais liberdade de escolha para compras em supermercados, mercearias, açougues e hortifrutis'
                },
                {
                    icon: 'valor_recomendado.svg',
                    title: 'Valor recomendado <br/> por cartão',
                    description:
                        'Varia por região do pais. <br/> Quer uma sugestão? <a rel="noopener noreferrer" target="_blank" href="http://www.pesquisaprecomedio.com.br/preco-medio-alimentacao.php">Clique aqui</a>'
                },
                {
                    icon: 'quantidade_minima.svg',
                    title: 'Quantidade mínima',
                    description: 'A partir de 1 cartão'
                },
                {
                    icon: 'rede_aceitacao.svg',
                    title: 'Rede de aceitação',
                    description: 'Rede Alimentação'
                },
                {
                    icon: 'entrega.svg',
                    title: 'Prazo de entrega do cartão',
                    description:
                        'Cartão: 5 dias úteis nas capitais e 7 dias úteis nas demais localidades'
                },
                {
                    icon: 'recarga.svg',
                    title: 'Prazo de recarga',
                    description: 'Recarga: Até 3 dias após o pagamento'
                },
                {
                    icon: 'forma_pagamento.svg',
                    title: 'Forma de pagamento',
                    description:
                        'Boleto' +
                        (CREDIT_CARD_PAYMENT
                            ? ' ou Cartão de Crédito <br/> (Elo Corporativo)'
                            : '')
                },
                {
                    icon: 'meu_alelo.svg',
                    title: 'Meu Alelo',
                    description:
                        'Consulte no app seu saldo e extrato, veja rede de aceitação e tenha vantagens exclusivas. Disponível para Android e IOS'
                },
                {
                    icon: 'clube_alelo.svg',
                    title: 'Clube Alelo',
                    description:
                        'São mais de 200 ofertas toda semana, 5 mil estabelecimentos e descontos que chegam até 80%'
                }
            ],
            faq: [
                {
                    title: 'O que é o Alelo Alimentação?',
                    answer: `
                        É um benefício que a empresa pode oferecer a seus colaboradores para a compra de produtos alimentícios. Aceito em mais de 260 mil
                        estabelecimentos, entre supermercados, açougues, mercearias, padarias e similares de todo o Brasil, o cartão é uma ótima alternativa às cestas
                        físicas – que exigem espaço para armazenamento, cuidados quanto à validade dos alimentos e logística de distribuição das mesmas.
                    `
                },
                {
                    title: 'O que é o PAT?',
                    answer: `
                        O Programa de Alimentação do Trabalhador - PAT é um programa governamental, de adesão voluntária, que busca estimular o empregador a fornecer
                        alimentação nutricionalmente adequada aos trabalhadores, por meio da concessão de incentivos fiscais. Criado em 1976, o PAT reúne governo,
                        empresas, colaboradores e estabelecimentos comerciais com o objetivo de promover a saúde dos trabalhadores e a diminuir o número de casos de
                        doenças relacionadas à alimentação e à nutrição.
                    `
                },
                {
                    title: 'Qual o número mínimo de trabalhadores que uma empresa deverá ter para participar do PAT (Programa de Alimentação ao Trabalhador)?',
                    answer: 'A empresa poderá participar do PAT com a quantidade mínima de um trabalhador.'
                },
                {
                    title: 'A empresa pode conceder mais de um benefício ao trabalhador?',
                    answer: 'Sim. Independentemente da modalidade adotada para o fornecimento da refeição, a empresa beneficiária poderá oferecer aos seus trabalhadores um ou mais benefícios.'
                },
                {
                    title: 'Qual o limite para participação financeira do trabalhador no custeio do PAT?',
                    answer: `
                        A participação dos trabalhadores atendidos nos gastos envolvidos na operacionalização do PAT tem como limite 20% do custo direto dos benefícios
                        concedidos. Este limite é global e deve ser calculado para cada período de apuração (conforme a legislação reguladora do imposto sobre a renda),
                        limitado a doze meses.
                    `
                },
                {
                    title: 'Em caso de falta ao trabalho, a empresa pode reduzir o benefício do trabalhador?',
                    answer: 'Não. De acordo com art. 6º, inciso I da Portaria n° 03/2002, é vedado à empresa beneficiária do PAT suspender, reduzir ou suprimir o benefício do Programa a título de punição ao trabalhador.'
                },
                {
                    title: 'Quando um trabalhador é demitido logo após receber o benefício-alimentação, a empresa poderá descontá-lo na rescisão?',
                    answer: 'Sim. A empresa tem o direito de efetuar a distribuição antecipada do benefício-alimentação, podendo efetuar descontos dessa antecipação por ocasião de rescisão do contrato laboral.'
                },
                {
                    title: 'Em caso de férias, licença-maternidade e afastamentos, o trabalhador poderá receber o benefício?',
                    answer: 'Sim. Apesar de a empresa não ter obrigação de conceder alimentação quando o trabalhador é afastado por doença, licença ou férias, não há nada que a impeça de fazê-lo conceder o benefício ao trabalhador.'
                },
                {
                    title: 'As empresas de lucro presumido, arbitrado ou optantes pelo simples têm direito às vantagens do programa?',
                    answer: 'Sim, essas empresas são isentas do recolhimento do INSS e FGTS (encargos sociais) sobre o valor do benefício, no entanto, não fazem jus ao incentivo fiscal (dedução de até 4% da alíquota de 15% do IRPJ devido), que está restrito a empresas de Lucro Real.'
                },
                {
                    title: 'Os trabalhadores do mercado informal podem usufruir dos benefícios do PAT?',
                    answer: 'Não. O PAT atende apenas ao mercado formal de trabalho. É fundamental que haja o contrato de trabalho para participar do Programa.'
                }
            ],
            imgs: {
                desk: [{ full: '', thumb: '' }],
                mobile: [{ full: '', thumb: '' }]
            },
            form: {
                title: '',
                description: ''
            },
            info: {
                title: '',
                description: '',
                banner1: '',
                banner2: ''
            }
        },
        {
            code: MEAL,
            category: '',
            form: {
                title: '',
                description: ''
            },
            benefits: [
                {
                    icon: 'para_que_serve.svg',
                    title: 'Para que serve',
                    description:
                        'Pagamento de refeições em restaurantes, <br/> lanchonetes, padarias e similares'
                },
                {
                    icon: 'valor_recomendado.svg',
                    title: 'Valor recomendado <br/> por cartão',
                    description:
                        'Varia por região do pais. <br/> Quer uma sugestão? <a rel="noopener noreferrer" target="_blank" href="http://www.pesquisaprecomedio.com.br/preco-medio-refeicao.php">Clique aqui</a>'
                },
                {
                    icon: 'quantidade_minima.svg',
                    title: 'Quantidade mínima',
                    description: 'A partir de 1 cartão'
                },
                {
                    icon: 'rede_aceitacao.svg',
                    title: 'Rede de aceitação',
                    description: 'Rede Refeição'
                },
                {
                    icon: 'entrega.svg',
                    title: 'Prazo de entrega do cartão',
                    description:
                        'Cartão: 5 dias úteis nas capitais e 7 dias úteis nas demais localidades'
                },
                {
                    icon: 'recarga.svg',
                    title: 'Prazo de recarga',
                    description: 'Recarga: Até 3 dias após o pagamento'
                },
                {
                    icon: 'forma_pagamento.svg',
                    title: 'Forma de pagamento',
                    description:
                        'Boleto' +
                        (CREDIT_CARD_PAYMENT
                            ? ' ou Cartão de Crédito <br/> (Elo Corporativo)'
                            : '')
                },
                {
                    icon: 'meu_alelo.svg',
                    title: 'Meu Alelo',
                    description:
                        'Consulte no app seu saldo e extrato, veja rede de aceitação e tenha vantagens exclusivas. Disponível para Android e IOS'
                },
                {
                    icon: 'clube_alelo.svg',
                    title: 'Clube Alelo',
                    description:
                        'São mais de 200 ofertas toda semana, 5 mil estabelecimentos e descontos que chegam até 80%'
                }
            ],
            faq: [
                {
                    title: 'O que é o Alelo Refeição?',
                    answer: `
                        É um benefício que a empresa pode oferecer a seus colaboradores para as refeições. o cartão aceito em mais de 230 mil estabelecimentos comerciais,
                        entre restaurantes, lanchonetes, padarias, quilos, fast foods e muitos outros, espalhados por todas as cidades do Brasil. Mais liberdade de
                        escolha para seus funcionários, praticidade e economia para a sua empresa.
                    `
                },
                {
                    title: 'O que é o PAT?',
                    answer: `
                        O Programa de Alimentação do Trabalhador - PAT é um programa governamental, de adesão voluntária, que busca estimular o empregador a fornecer
                        alimentação nutricionalmente adequada aos trabalhadores, por meio da concessão de incentivos fiscais. Criado em 1976, o PAT reúne governo,
                        empresas, colaboradores e estabelecimentos comerciais com o objetivo de promover a saúde dos trabalhadores e a diminuir o número de casos de
                        doenças relacionadas à alimentação e à nutrição.
                    `
                },
                {
                    title: 'Qual o número mínimo de trabalhadores que uma empresa deverá ter para participar do PAT (Programa de Alimentação ao Trabalhador)?',
                    answer: 'A empresa poderá participar do PAT com a quantidade mínima de um trabalhador.'
                },
                {
                    title: 'A empresa pode conceder mais de um benefício ao trabalhador?',
                    answer: 'Sim. Independentemente da modalidade adotada para o fornecimento da refeição, a empresa beneficiária poderá oferecer aos seus trabalhadores um ou mais benefícios.'
                },
                {
                    title: 'Qual o limite para participação financeira do trabalhador no custeio do PAT?',
                    answer: `
                        A participação dos trabalhadores atendidos nos gastos envolvidos na operacionalização do PAT tem como limite 20% do custo direto dos benefícios
                        concedidos. Este limite é global e deve ser calculado para cada período de apuração (conforme a legislação reguladora do imposto sobre a renda),
                        limitado a doze meses.
                    `
                },
                {
                    title: 'Em caso de falta ao trabalho, a empresa pode reduzir o benefício do trabalhador?',
                    answer: 'Não. De acordo com art. 6º, inciso I da Portaria n° 03/2002, é vedado à empresa beneficiária do PAT suspender, reduzir ou suprimir o benefício do Programa a título de punição ao trabalhador.'
                },
                {
                    title: 'Quando um trabalhador é demitido logo após receber o benefício-refeição, a empresa poderá descontá-lo na rescisão?',
                    answer: 'Sim. A empresa tem o direito de efetuar a distribuição antecipada do benefício-refeição, podendo efetuar descontos dessa antecipação por ocasião de rescisão do contrato laboral.'
                },
                {
                    title: 'Em caso de férias, licença-maternidade e afastamentos, o trabalhador poderá receber o benefício?',
                    answer: 'Sim. Apesar de a empresa não ter obrigação de conceder alimentação quando o trabalhador é afastado por doença, licença ou férias, não há nada que a impeça de fazê-lo conceder o benefício ao trabalhador.'
                },
                {
                    title: 'As empresas de lucro presumido, arbitrado ou optantes pelo simples têm direito às vantagens do programa?',
                    answer: 'Sim, essas empresas são isentas do recolhimento do INSS e FGTS (encargos sociais) sobre o valor do benefício, no entanto, não fazem jus ao incentivo fiscal (dedução de até 4% da alíquota de 15% do IRPJ devido), que está restrito a empresas de Lucro Real.'
                },
                {
                    title: 'Os trabalhadores do mercado informal podem usufruir dos benefícios do PAT?',
                    answer: 'Não. O PAT atende apenas ao mercado formal de trabalho. É fundamental que haja o contrato de trabalho para participar do Programa.'
                }
            ],
            imgs: {
                desk: [{ full: '', thumb: '' }],
                mobile: [{ full: '', thumb: '' }]
            },
            info: {
                title: '',
                description: '',
                banner1: '',
                banner2: ''
            }
        },
        {
            code: CULTURE,
            category: '',
            form: {
                title: '',
                description: ''
            },
            benefits: [
                {
                    icon: 'para_que_serve.svg',
                    title: 'Para que serve',
                    description:
                        'Pagamento de ingressos em cinemas, teatros, shows, produtos em livraria, e muito mais'
                },
                {
                    icon: 'valor_recomendado.svg',
                    title: 'Valor recomendado <br/> por cartão',
                    description: 'Valor fixo: R$ 50,00 por cartão'
                },
                {
                    icon: 'quantidade_minima.svg',
                    title: 'Quantidade mínima',
                    description: 'A partir de 1 cartão'
                },
                {
                    icon: 'rede_aceitacao.svg',
                    title: 'Rede de aceitação',
                    description: 'Rede Cultura'
                },
                {
                    icon: 'entrega.svg',
                    title: 'Prazo de entrega do cartão',
                    description:
                        'Cartão: 5 dias úteis nas capitais e 7 dias úteis nas demais localidades'
                },
                {
                    icon: 'recarga.svg',
                    title: 'Prazo de recarga',
                    description: 'Recarga: Até 3 dias após o pagamento'
                },
                {
                    icon: 'forma_pagamento.svg',
                    title: 'Forma de pagamento',
                    description:
                        'Boleto' +
                        (CREDIT_CARD_PAYMENT
                            ? ' ou Cartão de Crédito <br/> (Elo Corporativo)'
                            : '')
                },
                {
                    icon: 'meu_alelo.svg',
                    title: 'Meu Alelo',
                    description:
                        'Consulte no app seu saldo e extrato, veja rede de aceitação e tenha vantagens exclusivas. Disponível para Android e IOS'
                },
                {
                    icon: 'clube_alelo.svg',
                    title: 'Clube Alelo',
                    description:
                        'São mais de 200 ofertas toda semana, 5 mil estabelecimentos e descontos que chegam até 80%'
                }
            ],
            faq: [
                {
                    title: 'O que é Alelo Cultura?',
                    answer: `
                        O Alelo Cultura é um benefício no valor de R$ 50,00, cumulativo, destinado aos colaboradores para o
                        consumo de bens, serviços e atividades culturais. Faz parte do programa Vale-Cultura do Governo
                        Federal, Lei 12.761 de 27/12/2012, permitindo que a empresa fique isenta de encargos sociais (INSS, FGTS, entre outros) sobre o valor do benefício.
                    `
                },
                {
                    title: 'Onde o meu colaborador pode utilizar o Alelo Cultura?',
                    answer: 'Em estabelecimentos de acesso a bens e atividades culturais como: cinemas, teatros, casas de espetáculos, museus, livrarias, papelarias, circos e centros de exposição. A rede de aceitação pode ser consultada através do aplicativo Meu Alelo ou pela Central de Atendimento ao Usuário.'
                },
                {
                    title: 'Minha empresa é obrigada a fornecer o Vale Cultura?',
                    answer: 'Não. O programa Vale Cultura é uma lei de incentivo e não obrigatória. '
                },
                {
                    title: 'Qualquer empresa pode fornecer o Alelo Cultura?',
                    answer: 'Sim. Qualquer empresa que contenha a partir de um colaborador.'
                },
                {
                    title: 'Como minha empresa pode participar do Programa Vale-Cultura?',
                    answer: `
                        Sua empresa pode adquirir o Alelo Cultura por meio desse site ou na nossa <a target="_blank" href="https://www.alelo.com.br/empresas/telefone">Central de Atendimento</a>.
                        Após a contratação, é preciso também se cadastrar no Programa de Cultura do Trabalhador através do site do <a target="_blank" href="http://vale.cultura.gov.br/">Governo Federal</a>.
                    `
                },
                {
                    title: 'A empresa pode descontar parte do valor do colaborador?',
                    answer: `Sim. O desconto varia de acordo com a faixa salarial do trabalhador:
                        <ul>
                            <li> De 01 a 05 salários mínimos: desconto de até R$ 5,00 – 10%</li>
                            <li> Acima de 05 salários mínimos: desconto de até R$ 45,00 – 90%</li>
                        </ul>
                    `
                },
                {
                    title: 'Posso fornecer o benefício em alguns meses e não disponibilizar em outros, de acordo com o resultado comercial da minha empresa?',
                    answer: 'Não. O produto é um benefício regulamentado, portanto, uma vez que a empresa se inscreva no Programa Vale Cultura e o colaborador tenham feito a adesão ao benefício, a disponibilização deve ser realizada de forma recorrente.'
                },
                {
                    title: 'Qual a validade do cartão?',
                    answer: 'Segue a mesma validade dos outros cartões Alelo: 5 anos. No entanto, caso o cartão fique sem utilização por 6 meses (180 dias), o cartão é considerado inativo e poderá ser cancelado.'
                },
                {
                    title: 'É possível fazer alteração do valor fornecido?',
                    answer: 'Não. De acordo com o Ministério da Cultura (MINC) o valor do benefício oferecido mensalmente deve ser de R$ 50,00.'
                }
            ],
            imgs: {
                desk: [{ full: '', thumb: '' }],
                mobile: [{ full: '', thumb: '' }]
            },
            info: {
                title: '',
                description: '',
                banner1: '',
                banner2: ''
            }
        },
        {
            code: CHRISTMAS,
            category: '',
            form: {
                title: '',
                description: ''
            },
            benefits: [
                {
                    icon: 'para_que_serve.svg',
                    title: 'Para que serve',
                    description:
                        'Substituto da cesta física de natal, com o cartão Alelo Natal o seu colaborador tem a liberdade de escolha para celebrar o fim de ano como quiser. Aceito em toda a rede credenciada Alelo como restaurantes, supermercados, açougues, postos de combustível e muito mais'
                },
                {
                    icon: 'valor_recomendado.svg',
                    title: 'Valor recomendado <br/> por cartão',
                    description:
                        '*R$ 200,00 <br /> * Cartão possibilita cargs entre R$ 50,00 e R$ 4.000,00'
                },
                {
                    icon: 'quantidade_minima.svg',
                    title: 'Quantidade mínima',
                    description: 'A partir de 1 cartão'
                },
                {
                    icon: 'rede_aceitacao.svg',
                    title: 'Rede de aceitação',
                    description: 'MultiRede Alelo'
                },
                {
                    icon: 'entrega.svg',
                    title: 'Prazo de entrega do cartão',
                    description:
                        'Cartão: 5 dias úteis nas capitais e 7 dias úteis nas demais localidades'
                },
                {
                    icon: 'recarga.svg',
                    title: 'Prazo de recarga',
                    description: 'Recarga: Até 3 dias após o pagamento'
                },
                {
                    icon: 'forma_pagamento.svg',
                    title: 'Forma de pagamento',
                    description:
                        'Boleto' +
                        (CREDIT_CARD_PAYMENT
                            ? ' ou Cartão de Crédito <br/> (Elo Corporativo)'
                            : '')
                },
                {
                    icon: 'meu_alelo.svg',
                    title: 'Meu Alelo',
                    description:
                        'Consulte no app seu saldo e extrato, veja rede de aceitação e tenha vantagens exclusivas. Disponível para Android e IOS'
                },
                {
                    icon: 'clube_alelo.svg',
                    title: 'Clube Alelo',
                    description:
                        'São mais de 200 ofertas toda semana, 5 mil estabelecimentos e descontos que chegam até 80%'
                }
            ],
            faq: [
                {
                    title: 'O que é o Alelo Natal?',
                    answer: 'O Cartão Alelo Natal é o jeito mais prático e inovador de presentear sua equipe, proporcionando multipossibilidades para celebrar o ano do jeito e onde quiserem.'
                },
                {
                    title: 'Onde posso utilizar o Alelo Natal?',
                    answer: 'Com Alelo Natal, você faz compras em supermercados, açougues e padarias integrantes da nossa Rede Alelo. E mais! Ele também é aceito nas maquininhas da Cielo para compras em restaurantes, livrarias, cinemas, farmácias e postos de combustíveis.'
                },
                {
                    title: 'Onde aceita o meu cartão Alelo Natal?',
                    answer: 'O Alelo Natal é aceito em toda a Multi Rede Alelo: supermercados, mercearias, padarias, açougues, restaurantes, teatros, cinemas, livrarias, postos de combustíveis, além de farmácias. Basta você entrar no app Meu Alelo, clicar no cartão que quer usar e no lado esquerdo selecionar a opção “Onde Aceita”. Lá, você ainda pode classificar da seguinte maneira: por estado, cidade, endereço e categoria de estabelecimentos.'
                },
                {
                    title: 'Qual o prazo de entrega do cartão?',
                    answer: 'Até 5 dias úteis nas capitais e até 7 dias úteis nas demais localidades após processamento do pedido.'
                },
                {
                    title: 'Como solicitar o Alelo Natal?',
                    answer: `Você pode solicitar o Alelo Natal por meio deste e-commerce (<a href="https://loja.alelo.com.br/">https://loja.alelo.com.br</a>).`
                },
                {
                    title: 'O Alelo Natal tem prazo de validade?',
                    answer: 'Sim, o cartão é valido por 3 anos. Entretanto, após 120 dias sem utilização, será cobrada uma tarifa mensal de manutenção do portador. Os saldos não expurgam.'
                },
                {
                    title: 'Existe um valor mínimo ou máximo que a empresa pode dar nesse cartão Natal a seus colaboradores?',
                    answer: `
                        Sim. Existem limites de carregamento:
                        <ul>
                            <li>Mínima: R$ 30 (trinta reais).</li>
                            <li>Máxima: R$ 4.400 (quatro mil e quatrocentos reais).</li>
                        </ul>
                    `
                },
                {
                    title: 'Qualquer empresa pode fornecer o Alelo Natal?',
                    answer: 'Sim. Qualquer empresa que contenha a partir de um colaborador.'
                },
                {
                    title: 'A empresa pode descontar parte do valor do colaborador?',
                    answer: 'Não. O Cartão Alelo Natal não faz parte do programa PAT.'
                },
                {
                    title: 'Quais são as taxas e tarifas de utilização do cartão?',
                    answer: 'Tarifa de Manutenção Mensal, Tarifa de Reemissão e Tarifa de Rescisão.'
                }
            ],
            imgs: {
                desk: [{ full: '', thumb: '' }],
                mobile: [{ full: '', thumb: '' }]
            },
            info: {
                title: '',
                description: '',
                banner1: '',
                banner2: ''
            }
        }
    ]
}

export const internalProductReducer = (
    state = initialState,
    action = { type: '' }
) => {
    switch (action.type) {
        case product.SET_PRODUCT:
            return {
                ...state,
                code: action.payload.code,
                min: action.payload.min,
                max: action.payload.max
            }
        case product.ADD_PRODUCT: {
            const productsIndex = state.products.findIndex(
                (prod) => prod.code === action.payload.code
            )
            const index =
                productsIndex > -1 ? productsIndex : state.products.length
            return {
                ...state,
                products: [
                    ...state.products.slice(0, index),
                    {
                        ...state.products[index],
                        imgs: action.payload.data.imgs,
                        category: action.payload.data.path,
                        form: action.payload.data.product,
                        info: action.payload.data.info
                    },
                    ...state.products.slice(index + 1)
                ]
            }
        }
        case product.CLEAR:
            return initialState
        default:
            return state
    }
}
